import { useEffect, useState } from "react";
import { fetchMyRolePermissions } from "../api/myRolePermissionsApi";

/**
 * Loads User builder submodule permissions for the current role.
 * Lives under visitor feature (not public/) so screens respect assigned access.
 */
export function useVisitorRolePermissions(roleSlug, enabled = true) {
  const [permissions, setPermissions] = useState({});
  const [isUnrestricted, setIsUnrestricted] = useState(false);
  const [loading, setLoading] = useState(Boolean(enabled && roleSlug));
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled || !roleSlug) {
      setLoading(false);
      return undefined;
    }

    let cancelled = false;

    (async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchMyRolePermissions(roleSlug);
        if (cancelled) return;
        setPermissions(
          data?.permissions && typeof data.permissions === "object"
            ? data.permissions
            : {},
        );
        setIsUnrestricted(Boolean(data?.isUnrestricted));
      } catch (err) {
        if (cancelled) return;
        if (err?.status === 401 || err?.message === "session_timeout") {
          return;
        }
        setPermissions({});
        setIsUnrestricted(false);
        setError(err?.message || "Failed to load permissions");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [roleSlug, enabled]);

  return { permissions, isUnrestricted, loading, error };
}
